var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailWhile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.834,
    height: 15.413,
    viewBox: "0 0 22.834 15.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,18.116V5.433q0-.022.066-.418L7.6,11.4.16,18.557a1.866,1.866,0,0,1-.088-.44ZM1.063,4.134a.949.949,0,0,1,.374-.066h20.1a1.247,1.247,0,0,1,.4.066l-7.487,6.408-.991.793L11.5,12.942,9.54,11.334l-.991-.793Zm.022,15.281,7.509-7.2L11.5,14.571l2.907-2.356,7.509,7.2a1.057,1.057,0,0,1-.374.066H1.437a1,1,0,0,1-.352-.066ZM15.4,11.4,22.84,5.015a1.314,1.314,0,0,1,.066.418V18.116a1.688,1.688,0,0,1-.066.44Z",
    transform: "translate(-0.072 -4.068)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailWhile);
export default __webpack_public_path__ + "static/media/icon-email-while.1af448d654c8e000c5e729b71c4be6dc.svg";
export { ForwardRef as ReactComponent };